import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';

export const ExpensesClaimIcon = () => <ReceiptLongOutlinedIcon />;
